import idleUrl from "../assets/coffee/mini-rel-idle-v3.png";
import sippingUrl from "../assets/coffee/mini-rel-sipping-v3.png";
import workingUrl from "../assets/coffee/mini-rel-working-v3.png";
import mugBlankUrl from "../assets/coffee/cream-mug-blank.png";
import mugFrontUrl from "../assets/coffee/cream-mug-front-with-open-interior.png";
import streamUrl from "../assets/coffee/separate-coffee-stream.png";
import carafeUrl from "../assets/coffee/carafe-no-stream.png";

/**
 * Idle, sipping, and working plates share one 1024×1536 portrait canvas.
 * Earlier landscape plates stay on disk as the v2 files.
 * The sipping plate paints the mug at her mouth, so the live floor mug
 * is hidden while that pose is showing.
 */
export const portraitLayers = {
  poseIdle: idleUrl,
  poseSipping: sippingUrl,
  poseWorking: workingUrl,
  mugBlank: mugBlankUrl,
  mugFront: mugFrontUrl,
  stream: streamUrl,
  carafe: carafeUrl,
};
